import { Fragment } from "react";
import { Transition } from "@headlessui/react";
import { Loader2 } from "lucide-react";

export default function ConfirmModal({
  isOpen,
  onClose,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "No",
  onConfirm,
  onCancel,
  isDeleting = false,
}) {
  if (!isOpen) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center">
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={!isDeleting ? onClose : undefined}
          />
        </Transition.Child>

        {/* Dialog */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="relative z-10 w-full max-w-md mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden px-8 py-8 text-center">
            {/* Title */}
            <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>

            {/* Message */}
            <p className="text-sm text-gray-500 leading-relaxed mb-8">{message}</p>

            {/* Actions */}
            <div className="flex gap-3 justify-center">
              <button
                onClick={onConfirm}
                disabled={isDeleting}
                className="flex-1 h-11 rounded-full bg-orange-500 hover:bg-orange-600 text-sm font-semibold text-white transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isDeleting ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Deleting...
                  </>
                ) : (
                  confirmLabel
                )}
              </button>
              <button
                onClick={onCancel || onClose}
                disabled={isDeleting}
                style={{ color: "#ffffff" }}
              className="flex-1 h-11 bg-gray-400 rounded-full text-white text-sm font-semibold disabled:opacity-50"
              >
                {cancelLabel}
              </button>
            </div>
          </div>
        </Transition.Child>
      </div>
    </Transition>
  );
}
